import React, { Component } from 'react';
import Features from "./Features";

import LockScreen from "./LockScreen";

export default class FeaturesRoot extends React.Component {

    constructor(props) {
        super();

        this.state = {
            isLocked: false,
        };
    }

    handleLock = (islock) => {
        this.setState({ isLocked: islock });
    };

    render() {

        const required = this.props.features.filter((f) => f.required === true);
        const additional = this.props.features.filter((f) => f.required === false);

        if (this.props.features.length === 0)
            return (<></>)

        return (
            <LockScreen isLocked={this.state.isLocked}>
                <div className="featuresRoot">
                    <div>
                        <h3>Основные параметры</h3>
                    </div>
                    <div>
                        <Features extDisable={this.props.extDisable} configurationId={this.props.configurationId} features={required} debug={this.props.debug} updateConfiguration={this.props.updateConfiguration} handleLock={this.handleLock} showError={this.props.showError} />
                    </div>
                </div>
                <div className="featuresRoot">
                    {additional.length > 0 &&
                        <>
                            <div>
                                <h3>Дополнительные параметры</h3>
                            </div>
                            <div>
                            <Features extDisable={this.props.extDisable} configurationId={this.props.configurationId} features={additional} debug={this.props.debug} updateConfiguration={this.props.updateConfiguration} handleLock={this.handleLock} showError={this.props.showError} />
                            </div>
                        </>
                    }
                </div>
            </LockScreen>
        );
    }
}